import { apiFetch } from "../../../lib/api/client";

export interface VoiceOpenAIKeyStatus {
  configured: boolean;
  validation: string;
  maskedKey: string | null;
  source: string;
  updatedAt: string | null;
}

export interface VoiceRagStatus {
  state: string;
  jobId: string | null;
  documentCount: number;
  chunkCount: number;
  ignoredFileCount: number;
  lastSuccessAt: string | null;
  error: string | null;
}

export interface VoiceRagBuildResult {
  jobId: string;
  state: string;
}

export interface VoiceRagSearchResult {
  content: string;
  source: string | null;
  sectionIndex: number | null;
  score: number;
}

export interface VoicePersona {
  name: string;
  roleObjective: string;
  notes: string;
  speechStyle: string;
  voiceGender: string;
  defaultsVersion: number;
  isCustomized: boolean;
}

export interface VoiceConversationConfig {
  ready: boolean;
  requirements: {
    api_key_ready: boolean;
    rag_ready: boolean;
    persona_ready: boolean;
  };
  protocolVersion: number;
  audio: {
    format: string;
    sample_rate: number;
    channels: number;
  };
  inputModes: string[];
  outputModes: string[];
  assistantName: string;
  voiceGender: string;
  voice: string;
}

export function getVoiceConversationConfig(): Promise<VoiceConversationConfig> {
  return apiFetch("/voice/config");
}

export function getVoiceOpenAIKeyStatus(): Promise<VoiceOpenAIKeyStatus> {
  return apiFetch("/voice/openai-key/status");
}

export async function uploadVoiceOpenAIKey(file: File): Promise<VoiceOpenAIKeyStatus> {
  const body = new FormData();
  body.set("file", file);
  return apiFetch("/voice/openai-key", { method: "POST", body });
}

export function getVoiceRagStatus(): Promise<VoiceRagStatus> {
  return apiFetch("/voice/rag/status");
}

export async function buildVoiceRag(file: File): Promise<VoiceRagBuildResult> {
  const body = new FormData();
  body.set("file", file);
  return apiFetch("/voice/rag/build", { method: "POST", body });
}

export async function searchVoiceRag(
  query: string,
  topK = 4,
): Promise<VoiceRagSearchResult[]> {
  return apiFetch("/voice/rag/search", {
    method: "POST",
    body: JSON.stringify({ query, topK }),
  });
}

export function getVoicePersona(): Promise<VoicePersona> {
  return apiFetch("/voice/persona");
}

export async function saveVoicePersona(payload: Omit<VoicePersona, "defaultsVersion" | "isCustomized">): Promise<VoicePersona> {
  return apiFetch("/voice/persona", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function resetVoicePersona(): Promise<VoicePersona> {
  return apiFetch("/voice/persona/reset", { method: "POST" });
}
